// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';
import { getABtestFromState } from '@tcp/core/src/utils';
import { getMultiPackProductInfo } from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.selectors';
import { getMultiPackProductInfo as getMultiPackProductInfoPickUp } from '@tcp/core/src/components/common/organisms/PickupStoreModal/container/PickUpStoreModal.selectors';

export const getStickyATCABTest = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  return getAbtests.hideStickyATC;
};

const getMultipackData = (multipackProduct) => {
  return (
    multipackProduct &&
    multipackProduct.multiPackData &&
    multipackProduct.multiPackData.newPartNumber
  );
};

const getMultipackColor = (multipackProduct) => {
  return (
    multipackProduct &&
    multipackProduct.multiPackData &&
    multipackProduct.multiPackData.getNewMultiPackAllColor
  );
};

export const getMultipackProductQV = createSelector(getMultiPackProductInfo, getMultipackData);

export const getAllNewMultiPackQV = createSelector(getMultiPackProductInfo, getMultipackColor);

export const getMultipackProductPickup = createSelector(
  getMultiPackProductInfoPickUp,
  getMultipackData
);

export const getAllNewMultiPackPickup = createSelector(
  getMultiPackProductInfoPickUp,
  getMultipackColor
);
